module.exports = __webpack_public_path__ + "assets/img/crayon9.d2632727.png";